import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from './cn.js';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Élévation au survol (cartes cliquables). */
  interactive?: boolean;
  padded?: boolean;
}

/** Carte : fond surface, bordure 1 px, rayon 8 px, ombre od-1 puis od-2 au survol, sans translation. */
export function Card({ interactive, padded = true, className, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-md border border-line-soft bg-surface shadow-od-1',
        interactive && 'transition-shadow duration-base ease-od hover:border-line hover:shadow-od-2',
        padded && 'p-5',
        className,
      )}
      {...rest}
    />
  );
}

export function CardHeader({
  title,
  eyebrow,
  actions,
  className,
}: {
  title: ReactNode;
  eyebrow?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('mb-4 flex items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        {eyebrow && (
          <div className="mb-1 font-display text-[11px] uppercase tracking-[0.18em] text-ink-3">
            {eyebrow}
          </div>
        )}
        <h3 className="font-display text-base font-bold leading-tight text-ink">{title}</h3>
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
